export default __webpack_public_path__ + "static/media/SamuelShumCv.a0e81838.pdf";